const Service = require('@virtual-peaker/vp-common').vpLocalization;

export default Service;
